import React from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import { ReactComponent as BigCheckIcon } from '../../assets/icons/big-check.svg';
import CustomButton from '../reusable/Buttons/Button';

const SupportTicketSuccess = ({ onClose }) => {
  return (
    <SuccessWrapper>
      <StyledIcon />
      <Message>{I18n.t('Thank you_ We will aim to respond at the earliest_')}</Message>
      <CloseButton handler={onClose}>{I18n.t('Close')}</CloseButton>
    </SuccessWrapper>
  );
};

SupportTicketSuccess.propTypes = {
  onClose: func.isRequired,
};

const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem 0;
`;

const StyledIcon = styled(BigCheckIcon)`
  width: 6.4rem;
  height: 6.4rem;
  margin-bottom: 2rem;
`;

const Message = styled.p`
  font-size: ${(props) => props.theme.fontSizes.normal};
  font-weight: bold;
  color: ${(props) => props.theme.colors.darkBlue2};
  margin-bottom: 2.4rem;
`;

const CloseButton = styled(CustomButton)`
  width: 16rem;
`;

export default SupportTicketSuccess;
